function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import InputLikeCheckboxRadio from 'components/Form/InputLikeCheckboxRadio';
import App from 'modules/App';
import Button from 'components/Form/Button';
import messages from '../../messages';
var _React_PureComponent;
class ChooseDatabase extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { database } = this.props;
        const formValues = {
            values: {
                database
            }
        };
        return /*#__PURE__*/ _jsxs(Form, {
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "database",
                    formValues: formValues,
                    children: /*#__PURE__*/ _jsx(InputLikeCheckboxRadio, {
                        labelMessage: App.constants.PATIENT_DATABASES.GlucoControDesktop.label,
                        inputValue: "GlucoControDesktop",
                        containerClassName: "col-12",
                        isRadio: true,
                        onChange: (input)=>this.props.onSetDatabase(input.value)
                    })
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "database",
                    formValues: formValues,
                    children: /*#__PURE__*/ _jsx(InputLikeCheckboxRadio, {
                        labelMessage: App.constants.PATIENT_DATABASES.GlucoFactsDelux.label,
                        inputValue: "GlucoFactsDelux",
                        containerClassName: "col-12",
                        isRadio: true,
                        onChange: (input)=>this.props.onSetDatabase(input.value)
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "quaternary",
                                labelMessage: messages.buttons.close,
                                className: "btn--block mt-4",
                                onClick: ()=>this.props.onCancel()
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "primary",
                                labelMessage: messages.buttons.next,
                                className: "btn--block btn--filled mt-4",
                                onClick: ()=>this.props.onSetComponent('ImportPatientDatabase')
                            })
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(ChooseDatabase, "propTypes", {
    database: PropTypes.oneOf(Object.keys(App.constants.PATIENT_DATABASES)),
    onCancel: PropTypes.func,
    onSetComponent: PropTypes.func,
    onSetDatabase: PropTypes.func
});
export default ChooseDatabase;
